import { shopifyFetch } from './api.js';

export async function createCart() {
	const query = `
    mutation {
      cartCreate {
        cart {
          id
          totalQuantity
        }
      }
    }
  `;
	const data = await shopifyFetch(query);
	return data.cartCreate.cart;
}

export async function getCart(cartId) {
	const query = `
    query GetCart($cartId: ID!) {
      cart(id: $cartId) {
        id
        totalQuantity
      }
    }
  `;
	const data = await shopifyFetch(query, { cartId });
	return data.cart;
}
